module.exports = __webpack_public_path__ + "img/image30.03cc47ca.png";